import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

function CustomTooltip({ title = "Tooltip", position = "top", children }) {
    return (
        <OverlayTrigger
            placement={position}
            overlay={
                <Tooltip id={`tooltip-${position}`}>
                    <strong>{title}</strong>
                </Tooltip>
            }
        >
            {children}
        </OverlayTrigger>
    )
}

export default CustomTooltip
